import { isSubscriptionPendingCancellation } from 'src/data/subscription';

import { useCurrentCustomer } from './useCurrentCustomer';

export const useIsSubscriptionPendingCancellation = () => {
  const currentCustomer = useCurrentCustomer();
  return isSubscriptionPendingCancellation(currentCustomer);
};
